import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import '../../../assets/styles/StylePopup.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { VariableSuppliers } from './VariableSuppliers';
import { postSupplier, putSupplier } from '../../../store/Actions/ActionSuppliers';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';


function EditSupplier({ arr, open, setOpen }) {

  const { mode, dispatch, navigate, langLocal } = AbstructVar();

  const { translate } = AbstructLang();
  const { state, setStateCustom, setLoad, setState } = VariableSuppliers();
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      first_name: arr.first_name,
      last_name: arr.last_name,
      phone_number: arr.phone_number,
      photo_identification: arr.photo_identification,
      sn: arr.sn,
      email: arr.email,
      role: arr.role,
    }));
  }, [arr]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(putSupplier(arr.id,state.first_name,state.last_name,state.phone_number,state.sn,state.email,state.role,state.photo_identification, setLoad));
  };

  const formFields = [
    { name: 'first_name', label: 'first_name', type: 'text', inputType: 'text', iconType: "pencil" },
    { name: 'last_name', label: 'last_name', type: 'text', inputType: 'text', iconType: "pencil" },
    { name: 'phone_number', label: 'phone_number', type: 'number', inputType: 'text', iconType: "phone" },
    { name: 'sn', label: 'SN', type: 'number', inputType: 'text', iconType: "pencil" },
    { name: 'email', label: 'email', type: 'email', inputType: 'text', iconType: "envelope" },
    { name: 'photo_identification', label: 'photo_identification', type: 'number', inputType: 'text', iconType: "pencil" },
    {
      name: "role", label: "roles", type: "text", inputType: 'one_select', iconType: "role",
      options: [{ value: 'manager', label: 'manager' }, { value: 'reader', label: 'reader' }, { value: 'supplier', label: 'supplier' }]
    },
  ];

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: 'popupR',
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
        <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
          <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit_suppliers')}</p>
        </div>
        <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="edit" />
      </div>
    </RModal>
  );
}

export default EditSupplier;